import React from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Box } from '@mui/material';

const DatePickerCustom = ({
  value,
  setValue,
  viewDetails,
  fullWidth = false,
  error,
  helperText,
  readOnly = false,
  maxWidth,
  label,
  disabled = false,
  sx,
  restrtictTyping,
  dateDisplayFormat = 'DD-MM-YYYY',
  height = '100%',
  fontSize = '100%',
  disableFuture = false,
  // Optional: shrink the calendar popup to this fraction (0 < x < 1), for a page shown scaled down. Unset (or 1) changes nothing.
  popupScale,
}) => {
  return (
    <Box  sx={{ width: fullWidth ? "100%" : undefined, ...sx }}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          disabled={disabled}
          readOnly={readOnly}
          disableFuture={disableFuture}
          slotProps={{
            ...(popupScale && popupScale < 1 ? { desktopPaper: { sx: { zoom: popupScale } } } : {}),
            textField: {
              fullWidth: fullWidth,
              error: error,
              helperText: helperText,
              label: label,
              InputProps: {
                readOnly: restrtictTyping,
                sx: {
                  height: height,
                  fontSize: fontSize,
                },
              },
              InputLabelProps: {
                sx: {
                  fontSize: fontSize,
                },
              },
              ...(restrtictTyping && {
                onKeyDown: (e) => e.preventDefault(),
              }),
            },
          }}
          displayStaticWrapperAs="desktop"
          views={viewDetails}
          value={value} //NEEDED FULL DATE TO DISPLAY
          onChange={(newValue) => setValue(newValue)}
          format={dateDisplayFormat}
        />
      </LocalizationProvider>
    </Box>
  );
};

export default DatePickerCustom;
